export class Message {
    public id: number;
    public title: string;
    public text: string;
    public published = false;
    public publish_date: Date;
    public updated_at: Date;
}
